import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class ContextDataAPI extends BaseAPI {
  /**
     * @description Lấy context-data theo user đăng nhập
     * @returns
     * @author PHNam
     */
  async getContextData () {
    return await this.getAsync('context-data')
  }
}

export default new ContextDataAPI('v1/system', null, getApiUrl(apis.CommonAPI))
